import script from "./UpdateNotificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateNotificationModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateNotificationModal.vue?vue&type=style&index=0&id=22fa3ee1&lang=css"

const __exports__ = script;

export default __exports__